import React from 'react';
import { CheckIcon, XIcon, AwardIcon, ShoppingCartIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function AnifitSolution() {
  const commercialFood = ['Conserveringsmiddelen die bacteriën doden', 'Kleurstoffen en smaakversterkers', 'Diermelen en vulstoffen', 'Focus op lage productiekosten', 'Onduidelijke herkomst'];
  const anifitBenefits = ['90-99% voedselveilig vlees, precies wat een carnivoor nodig heeft', 'Géén conserveringsmiddelen die goede bacteriën doden', "Géén kleurstoffen, smaakversterkers of kunstmatige aroma's", 'Géén diermelen, granen of vulstoffen die het spijsverteringsstelsel belasten', 'Geproduceerd in Zweden met de strengste dierenwelzijnswetgeving', 'Natuurlijke ondersteuning voor opbouw van een gezonde darmflora'];
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-amber-50 to-white" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-16">
        <div className="text-center mb-8 sm:mb-12" data-id="element-17">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[rgb(var(--color-neutral-900))] mb-3 sm:mb-4" data-id="element-18">
            De Oplossing: Voeding Zoals de Natuur het Bedoeld Heeft
          </h2>
          <p className="text-lg sm:text-xl text-[rgb(var(--color-neutral-800))] max-w-3xl mx-auto" data-id="element-19">
            Dit is het merk waar we het over hebben:{' '}
            <span className="font-bold text-[rgb(var(--color-primary))]" data-id="element-20">
              Anifit
            </span>
          </p>
        </div>

        <div className="mb-8 sm:mb-12 max-w-4xl mx-auto" data-id="element-21">
          <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed" data-id="element-22">
            De filosofie van Anifit wijkt fundamenteel af van de klassieke
            voederindustrie. Bij hen draait het niet om lage productiekosten of
            fancy marketing. Het draait om één ding: gezonde voeding die
            aansluit bij de natuurlijke behoeften van de carnivoor (vleeseter).
          </p>
        </div>

        {/* Mobile: Anifit first (solution), then Commercial (problem) */}
        {/* Desktop: Commercial left, Anifit right */}
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12" data-id="element-23">
          {/* Anifit - Shows FIRST on mobile */}
          <div className="order-1 lg:order-2 bg-gradient-to-br from-green-50 to-emerald-50 p-6 sm:p-8 rounded-2xl border-2 border-green-300 relative" data-id="element-24">
            <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2" data-id="element-25">
              <div className="bg-[rgb(var(--color-secondary))] text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full font-bold flex items-center gap-2 shadow-lg text-sm sm:text-base" data-id="element-26">
                <AwardIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-27" />
                Winnaar
              </div>
            </div>

            <h3 className="text-xl sm:text-2xl font-bold text-green-800 mb-4 sm:mb-6 text-center mt-4" data-id="element-28">
              Anifit
            </h3>
            <div className="space-y-3 sm:space-y-4" data-id="element-29">
              {anifitBenefits.map((item, index) => <div key={index} className="flex items-start gap-3 bg-white/60 p-3 sm:p-4 rounded-lg" data-id="element-30">
                  <CheckIcon className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 flex-shrink-0 mt-0.5 sm:mt-1" data-id="element-31" />
                  <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))] font-medium" data-id="element-32">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Commercial Food - Shows SECOND on mobile */}
          <div className="order-2 lg:order-1 bg-gradient-to-br from-gray-100 to-gray-200 p-6 sm:p-8 rounded-2xl border-2 border-gray-300" data-id="element-33">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-700 mb-4 sm:mb-6 text-center" data-id="element-34">
              Commercieel Voer
            </h3>
            <div className="space-y-3 sm:space-y-4" data-id="element-35">
              {commercialFood.map((item, index) => <div key={index} className="flex items-start gap-3 bg-white/60 p-3 sm:p-4 rounded-lg" data-id="element-36">
                  <XIcon className="w-5 h-5 sm:w-6 sm:h-6 text-red-600 flex-shrink-0 mt-0.5 sm:mt-1" data-id="element-37" />
                  <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))]" data-id="element-38">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        <a href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284379/proefpakket-hond?new_client_country=NL&category=62183&refconsultant=487050" target="_blank" rel="noopener noreferrer" className="block bg-gradient-to-r from-[rgb(var(--color-primary))] to-emerald-700 text-white p-6 sm:p-8 rounded-2xl text-center max-w-3xl mx-auto shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-[1.02] cursor-pointer" data-id="element-39">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bVZMAbdRfRewy2Ku85UXss/d99259a8-96a2-4ec0-96b0-48694b6d8ac5.png" alt="Blije hond met Anifit producten" className="w-48 h-48 sm:w-56 sm:h-56 object-contain mx-auto mb-4" data-id="element-40" />
          <p className="text-xl sm:text-2xl font-bold mb-2" data-id="element-41">
            Het verschil is duidelijk
          </p>
          <p className="text-lg sm:text-xl mb-4" data-id="element-42">
            Kies voor gezondheid, kies voor natuur
          </p>
          <p className="text-base sm:text-lg mb-4 font-semibold" data-id="element-43">
            Krijg 10% korting met code "stresslessdogs"
          </p>
          <div className="flex items-center justify-center gap-2 bg-white/20 backdrop-blur-sm rounded-lg px-6 py-3 inline-flex font-semibold text-base sm:text-lg hover:bg-white/30 transition-colors" data-id="element-44">
            <ShoppingCartIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-45" />
            Bestel Anifit proefpakket voor uw hond
          </div>
        </a>
      </div>
    </section>;
}